import { NostrEvent } from '@nostr/tools/core'
import { useTranslation } from 'react-i18next'

export default function Title({
  parentEvents,
  parentExternal
}: {
  parentEvents?: NostrEvent[]
  parentExternal?: string
}) {
  const { t } = useTranslation()

  if (parentEvents && parentEvents.length > 1)
    return (
      <div className="flex gap-2 items-center w-full">
        <div className="shrink-0">{t('Bulk Reply')}</div>
      </div>
    )

  if (parentEvents)
    return (
      <div className="flex gap-2 items-center w-full">
        <div className="shrink-0">{t('Reply to')}</div>
      </div>
    )

  if (parentExternal)
    return (
      <div className="flex gap-2 items-center w-full">
        <div className="shrink-0">{t('Comment on')}</div>
      </div>
    )

  return (
    <div className="flex gap-2 items-center w-full">
      <div className="shrink-0">{t('New Note')}</div>
    </div>
  )
}
